import { useNavigate } from "react-router-dom";
import { CheckCircle, Phone, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function SuccessPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      
      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="max-w-lg w-full text-center animate-fadeIn">
          {/* Logo */}
          <div className="mb-6 flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_intake-hub-6/artifacts/l9bs5fno_Cletis%20Logo.png"
              alt="Red River Internet Auto Sales"
              className="h-28 w-auto object-contain"
              data-testid="success-logo"
            />
          </div>

          {/* Success Icon */}
          <div className="mb-8 flex justify-center">
            <div className="w-24 h-24 rounded-full bg-green-50 flex items-center justify-center">
              <CheckCircle className="w-14 h-14 text-green-500" />
            </div>
          </div>

          {/* Success Message */}
          <h1 
            className="text-4xl md:text-5xl font-black tracking-tight text-slate-900 mb-4"
            style={{ fontFamily: 'Chivo, sans-serif' }}
            data-testid="success-title"
          >
            Thank You!
          </h1>
          
          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            Your information has been submitted successfully. One of our team members will contact you within 24 hours to discuss your vehicle needs.
          </p>

          {/* Contact Info */}
          <div className="bg-slate-50 rounded-xl p-6 mb-8">
            <p className="text-sm font-semibold uppercase tracking-wider text-slate-500 mb-3">
              Need Immediate Assistance?
            </p>
            <a 
              href="tel:+13467187187"
              className="inline-flex items-center gap-2 text-xl font-bold text-[#A52A2A] hover:text-[#8B2323] transition-colors"
              data-testid="contact-phone"
            >
              <Phone className="w-5 h-5" />
              (346) 718-7187
            </a>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="gap-2 px-6 py-3 border-2 border-slate-200 hover:border-slate-900 font-bold uppercase tracking-wide"
              data-testid="back-home-btn"
            >
              <Home className="w-4 h-4" />
              Back to Home
            </Button>
            
            <a
              href="tel:+13467187187"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#A52A2A] hover:bg-[#8B2323] text-white font-bold uppercase tracking-wide rounded-md transition-all transform hover:-translate-y-0.5 shadow-[0_4px_14px_0_rgba(213,0,0,0.39)]"
              data-testid="success-call-us-btn"
            >
              <Phone className="w-4 h-4" />
              Call Us
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
